import "./basket";
import "./datepicker";

window.userId = $("meta[name=user-id]").attr('content');

window._ = require('lodash');

// Библиотека для обработки HTTP запросов
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}


try {
    /** Важно!!! window.$ не работает для jquery, используйте global. **/
    global.JQuery = global.$;
} catch (e) {}




require('./vue');

window.Compare = require('./libs/Compare');
window.Basket = require('./libs/Basket');
window.Like = require('./libs/Like');

$(document).ready(function(){
    if (Compare) {
        console.log('Запущен отложенное событие Compare');
    }
    if (Basket) {
        console.log('Запущен отложенное событие Basket');
    }
    if (Like) {
        console.log('Запущен отложенное событие Like');
    }
    require('./handlers/events.js');
});
